import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { truncateText } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import EasyTooltip from 'components/EasyTooltip';
import Ranking from './Ranking';
import { useHighlightedText } from 'hooks/useHighlightedText';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TextLinkWithCoverArea = styled.span.withConfig({
  displayName: "CardLink__TextLinkWithCoverArea",
  componentId: "sc-llgwpv-0"
})(["display:block;color:inherit;text-decoration:none;&.focus-visible{outline:3px solid ", ";outline-offset:3px;}&::after{content:'';", " z-index:", ";}"], function (p) {
  return p.theme.links;
}, fillParent, function (p) {
  return p.theme.globals.z.raised - 1;
});
export function CardLink(_ref) {
  var children = _ref.children,
    rank = _ref.rank,
    link = _ref.link,
    maxLength = _ref.maxLength,
    isFocusDisabled = _ref.isFocusDisabled;
  var _useHighlightedText = useHighlightedText(),
    highlightText = _useHighlightedText.highlightText,
    highlights = _useHighlightedText.highlights;
  var TextLinkComponent = link ? Link : 'span';
  var tooltipContent = maxLength && typeof children === 'string' && children.length > maxLength ? children : null;
  var title = maxLength ? truncateText(children, maxLength) : children;
  var titleFragments = highlights && title ? highlightText(title) : title;
  return /*#__PURE__*/_jsx(EasyTooltip, {
    content: tooltipContent,
    children: /*#__PURE__*/_jsxs(TextLinkWithCoverArea, {
      to: link,
      as: TextLinkComponent,
      "aria-hidden": isFocusDisabled ? 'true' : undefined,
      tabIndex: isFocusDisabled ? Number('-1') : undefined,
      children: [/*#__PURE__*/_jsx(Ranking, {
        rank: rank
      }), titleFragments]
    })
  });
}